import styled from "styled-components";
import { Heading5Regular } from "../../../../common/Typography/Heading5";
import { Paragraph16Regular } from "../../../../common/Typography/Paragraph16";

const Container = styled.div``;

const Title = styled(Heading5Regular)`
  padding-top: 90px;
  text-align: center;
`;

const Description = styled(Paragraph16Regular)`
  opacity: 0.7;
  text-align: center;
`;

interface ISignupTitleProps {
  title: string;
  description: string;
}

const SignupTitle = ({ title, description }: ISignupTitleProps) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

export default SignupTitle;
